module.exports = __webpack_public_path__ + "static/media/icon_2.6c56ba26.png";